import type { DocumentPickerAsset } from 'expo-document-picker'; // File Type in native
import type { FileInputProps } from '../types';

const getRelativePath = (
  fileMeta: FileInputProps['fileMeta'],
  file: File | DocumentPickerAsset,
) => {
  if (fileMeta && 'path' in fileMeta && fileMeta.path) {
    return fileMeta.path;
  }

  // Handle relativePath from folder uploads (set by getFilesFromDataTransfer)
  if ('relativePath' in file && file.relativePath) {
    return file.relativePath as string;
  }

  // Handle webkitRelativePath from native folder input selection
  if ('webkitRelativePath' in file && file.webkitRelativePath) {
    return file.webkitRelativePath as string;
  }

  return '';
};

export { getRelativePath };
